import { lazy } from 'react';

// ----------------------------------------------------------------------

const EntryExitPage = lazy(() => import('../pages/EntryExit.page'));

// ----------------------------------------------------------------------

const EntryExitRoutes = [
    {
        path: '/human-resources/entry-exit',
        element: <EntryExitPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { EntryExitRoutes };
